import React, { useRef, useState, useEffect } from 'react';
import {Segment,Button,Container,Header, List, Form} from 'semantic-ui-react'
import {useHistory, Route, Switch} from 'react-router-dom'
import {SearchSelect} from '@wollo-lib/wollo-react'
import AddKunde from './AddKunde'

function PaketKorrektur(props) {

  const {shopId,kunden,setKunden,paketUID,db,dienst, setKorrektur}=props
  const paketeDB=db.pakete
  const usersDB=db.users
  const history=useHistory()
  const [paket,setPaket]=useState({Paketnummer:null })
    // select from nultiple customers or enter a new one

 

  const [modalOpen, setModalOpen]= useState(false)

  function handleChange(e,{name,value,result})
  {
    if(value)
    {
        if(name==='selectKunde' && kunden.length)
        {
            setKunden([kunden[value]])
            history.push(`/register/paket/${dienst}/select`)
        }
        else if(name==='searchKunde')
        {
            setKunden([{
                Vorname: result.Vorname,
                Nachname: result.Nachname,
                UID:result.value,
                Modus:result.Modus
            }])
            history.push(`/register/paket/${dienst}/select`)
        }


    }

  }

  const click= async (e,{name})=>
  {
      if(paketUID)
        await paketeDB.delete(paketUID)
      setKunden([])
      history.push(`/register/paket/${dienst}/scan`)  
  }

  useEffect(()=>{
      const getPaket= async ()=>
      {
          const myPaket=await paketeDB.get(paketUID)
          setPaket(myPaket)
      }

      if(paketUID)
        getPaket()

  },[paketUID])

  //        

  return (
  <>

        <Container >
        <Header as="h2" textAlign='center' style={{'margin-top':'3rem'}}>
            Paketnummer:  {paket.Paketnummer}
        </Header>
        <Switch>
            <Route exact path={'/register/paket/:Dienst/correct/addKunde'}>
                <AddKunde
                    dienst={dienst}
                    shopId={shopId}
                    setKunden={setKunden}
                    setKorrektur={setKorrektur}
                    db={db}
                />
             </Route>
             <Route exact path={'/register/paket/:Dienst/correct'}>
            
                
                    <Segment>
                    <Header as="h4" style={{'margin-top':'3rem'}}>Adressat bearbeiten</Header>
                    <Form>
                        <Form.Field
                                label='Kunde auswählen' 
                                value={paket.Kunde} 
                                name='searchKunde' 
                                onChange={handleChange} 
                                placeholder={'Kundennnamen suchen'}
                                control={SearchSelect}
                                Value2TitleUrl={{table: usersDB, field: 'UID', map: el=>(`${el.Vorname} ${el.Nachname} ${el.PLZ} ${el.Ort}`) }}
                                SuggestDexie={{ 
                                                table: usersDB,
                                                field:'fulltext', 
                                                map: el=> ({
                                                                key:el.UID, 
                                                                title:`${el.Vorname} ${el.Nachname} ${el.PLZ} ${el.Ort}`, 
                                                                value: el.UID,
                                                                Vorname:el.Vorname,
                                                                Nachname:el.Nachname,
                                                                Modus:el.Modus,
                                                                PLZ:el.PLZ,
                                                                Ort:el.Ort,
                                                                typ:'Kunde'})}} 
                                size='big'
                                autoSelect
                        />
                        <Button color='green' icon='plus' content='neuer Kunde' onClick={(e)=>{ history.push(`/register/paket/${dienst}/correct/addKunde`)}}/>
                
                        {
                            kunden.length<2 ?'' :
                            <>
                            <Header as='h4'>Vorschläge</Header>
                            <List>
                                    {
                                        kunden.map((kunde,index)=>(

                                            <List.Item style={{"margin-top":"4rem"}}

                                                header={`${kunde.Vorname} ${kunde.Nachname}`}
                                                name='selectKunde'
                                                onClick={handleChange}
                                                value={index}
                                                icon='user'
                                                size='big'
                                            />  


                                        ))

                                    }
                                </List>
                            </>
                                
                        }  
                    </Form> 
                </Segment>
                <Button size='big' name='wiederholen' onClick={click} content='Barcode Scan wiederholen' color='red'/>
            </Route>
          
        </Switch>
            
    </Container>

</>

)}




export default  PaketKorrektur
